module.exports = "bundlesFloorSlider.prototype = new RegistredModule();\nbundlesFloorSlider.prototype.constructor=bundlesFloorSlider;\n\nfunction bundlesFloorSlider() {\n  this.selector = $('.modal-sidebar--bundles');\n  this.bundleSliders = new Cube.InitSliderSlick(this.selector);\n}\n\nbundlesFloorSlider.prototype.loadingBusiness = function() { \n  this.bundleSliders.init();\n};\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/legacy/registrer/bundlesFloorSlider.legacy.js
// module id = 838
// module chunks = 33